export const menuColorManager = () => {
  const headerElement = document.querySelector('.js-header') as HTMLElement
  const overlayElement = document.querySelector('.js-header-menuOverlayUpper') as HTMLElement

  // Kill this if the header element is not found
  if (!headerElement || !overlayElement) { return }

  const menuLinks = headerElement.querySelectorAll('.js-headerMenuItem') as unknown as HTMLElement[]

  menuLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      const linkColor = link.dataset.color

      if (linkColor) {
        overlayElement.style.backgroundColor = linkColor
      }
    })

    link.addEventListener('mouseleave', () => {
      overlayElement.style.backgroundColor = ''
    })
  })
}
